import React from 'react';

export default class Timer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isRunning: false,
      mm: 0,
      ss: 0,
      ms: 0,
    };

    this.timerID = 0;

    this.start = () => {
      if (!this.state.isRunning) {
        this.toggle();
      }
    };

    this.stop = () => {
      if (this.state.isRunning) {
        this.toggle();
      }
    };

    this.reset = () => {
      clearInterval(this.timerID);
      this.setState({
        isRunning: false,
        mm: 0,
        ss: 0,
        ms: 0
      });
    };

    this.resetAndStart = () => {
      let { isRunning } = this.state;

      if (!isRunning) {
        this.reset();
        this.start();
      }
    };

    this.toggle = () => {
      let { isRunning } = this.state;

      if (isRunning) {
        // Running => Stop
        clearInterval(this.timerID);
      } else {
        // Stop => Running
        let { mm, ss, ms } = this.state;

        this.timerID = setInterval(() => {
          ms += 500;

          if (ms >= 1000) {
            ss++;
            ms = 0;
          }

          if (ss >= 60) {
            mm++;
            ss = 0;
          }

          this.setState({ mm, ss, ms });
        }, 500);
      }

      this.setState({ isRunning: !isRunning });
    };
  }

  // 1 => 01
  format(num) {
    return (num + '').length === 1 ? '0' + num : num + '';
  }

  getCurrentTime() {
    const { mm, ss, ms } = this.state;
    return `${this.format(mm)}:${this.format(ss)}:${this.format(ms)}`;
  }

  render() {
    return (
      <div className="stop-watch">
        <div>
          <span>{this.format(this.state.mm)}</span>:
          <span>{this.format(this.state.ss)}</span>
        </div>
      </div>
    );
  }
}